import React from 'react';
import { IonButton, IonModal, IonIcon } from '@ionic/react';
import { lockClosedOutline } from 'ionicons/icons';
import { useGlobalStore } from '../stateManagement/globalZustand';
import { _dict } from '../constants';
import { goToPayment } from '../payments';
import { useUserStore } from '../stateManagement/userZustand';
import ReactPlayer from 'react-player';
import { logMe } from '../../foo/user';

interface SubscriptionAlertProps {
    showAlert: boolean;
    setShowAlert: (show: boolean) => void;
}

const SubscriptionAlert: React.FC<SubscriptionAlertProps> = ({showAlert, setShowAlert}) => {
  const { lang } = useGlobalStore();
  const { userUniqueId } = useUserStore();
  const videoURL = "https://youtu.be/mm-uoExq6PA"
  
  return (
    <IonModal isOpen={showAlert}>
      <div style={{ textAlign: 'center', margin: '20px', fontSize: '18px', color: '#4A4A4A' }}>
        <IonIcon icon={lockClosedOutline} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
        {_dict.thisFeatureIsAvailableForSubscribedUsersOnly[lang]}
        <IonButton className="freeQuotaButton" onClick={() => {logMe("click_premium_artistic"); goToPayment(userUniqueId)}}>
            {_dict.freeQuotaPremiumBtnText[lang]}
        </IonButton>
      </div>
      <ReactPlayer url={videoURL} controls width="100%" height='100%' />
      <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
        <IonButton onClick={() => setShowAlert(false)} color="danger" size="large">
          {_dict.dismiss[lang]}
        </IonButton>
      </div>
    </IonModal>
  );
};

export default SubscriptionAlert;
